export const forgotPassword = (email: string) => `
    mutation {
        forgotPassword(email: "${email}") {
            message
            status
        }
    }
`;

export const recoverPassword = (email: string, code: string, password?: string) => `
    mutation {
        recoverPassword(email: "${email}" code: "${code}" ${password ? `password:"${password}"` : ''}) {
            message
            status
        }
    }
`;